import React from "react";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, Card, SectionTitle } from "@/components/ui/page";
import { Pill } from "@/components/StatusBadge";
import { fmtDateTime } from "@/lib/format";

export default function Profile() {
  const { user } = useAuth();
  const rows = [
    ["Employee ID", user.employee_id], ["Email", user.email], ["Pseudo Name", user.pseudo_name],
    ["Mobile", user.mobile], ["Process", user.process], ["Designation", user.designation],
    ["Deployed Role", user.deployed_role], ["Location", user.location], ["Shift", user.shift],
    ["Date of Joining", user.doj], ["RCM Experience", user.rcm_experience], ["Last Login", fmtDateTime(user.last_login)],
  ];
  return (
    <div>
      <PageHeader title="My Profile" subtitle="Your employee record" testId="profile-header" />
      <Card className="p-6" testId="profile-card">
        <div className="flex items-center gap-4 border-b border-slate-100 pb-5">
          <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-[#0B1F33] font-display text-2xl font-extrabold text-white">{user.name?.[0]}</div>
          <div>
            <h2 className="font-display text-xl font-bold text-[#0B1F33]">{user.name}</h2>
            <div className="mt-1 flex gap-2"><Pill tone="teal">{user.role.replace("_", " ")}</Pill><Pill tone={user.employment_status === "active" ? "green" : "slate"}>{user.employment_status}</Pill></div>
          </div>
        </div>
        <div className="mt-5 grid grid-cols-1 gap-x-8 gap-y-4 sm:grid-cols-2">
          {rows.map(([l, v]) => (
            <div key={l} className="flex justify-between border-b border-slate-50 py-1.5">
              <span className="text-sm text-slate-500">{l}</span>
              <span className="text-sm font-semibold text-[#0B1F33]">{v || "—"}</span>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
}
